export default "__VITE_ASSET__Ct_8jrNj__"